export default __webpack_public_path__ + "static/media/Läsårstider-hem-2024-2025.ddbff675.pdf";